(function () {

    'use strict';

    angular.module('iplusjs.filter.filterBy', [
        'lodash'
    ])
    .filter('filterBy', FilterBy);

    FilterBy.$inject = [
        '$filter',
        'lodash'
    ];
    function FilterBy($filter, _) {
        return function (value, expression) {
            var array = !_.isArray(value) ? _.toArray(value) : value;
            return $filter('filter')(array, expression);
        };
    }
})();
